import { apiClient } from "@/config/api";
import { SyncHistoryResponse } from "@/types/kkmovie";
import { ApiResponse } from "@/types/status";

const ENDPOINTS = {
  STATUS: "/movie-import/status",
  HISTORY: "/movie-import/history",
  IMPORT_ALL: "/movie-import/import-all",
  DAILY_TRIGGER: "/movie-import/daily-trigger",
  STOP: "/movie-import/stop",
} as const;

export interface MovieImportStatus {
  isImportAllRunning: boolean;
  isDailyImportRunning: boolean;
  latestImportAll?: any;
  latestDailyImport?: any;
}

export const movieImportService = {
  getImportStatus: async (): Promise<ApiResponse<MovieImportStatus>> => {
    return await apiClient.get(ENDPOINTS.STATUS);
  },

  getImportHistory: async (
    page: number = 1,
    limit: number = 20
  ): Promise<ApiResponse<SyncHistoryResponse>> => {
    return await apiClient.get(ENDPOINTS.HISTORY, { page, limit } as any);
  },

  triggerImportAll: async (
    source: "KKphim" | "OPhim"
  ): Promise<ApiResponse<any>> => {
    return await apiClient.post(ENDPOINTS.IMPORT_ALL, { source });
  },

  triggerDailyImport: async (): Promise<ApiResponse<any>> => {
    return await apiClient.post(ENDPOINTS.DAILY_TRIGGER);
  },

  stopImport: async (): Promise<ApiResponse<any>> => {
    return await apiClient.post(ENDPOINTS.STOP);
  },
};
